module.exports = __webpack_public_path__ + "assets/img/0-b5171ad6.jpg";